<a
  [matMenuTriggerFor]="menuEnabled() ? menu : null"
  class="container"
  [class]="containerClasses"
  [class.cursor-pointer]="menuEnabled()"
>
  @if (imageUrl()) {
    <img class="image" [src]="imageUrl()" alt="avatar" />
  } @else if (initials()) {
    <h1 class="initials" [style]="initialsStyles">{{ initials() }}</h1>
  } @else {
    <img class="image placeholder" src="assets/images/avatar.svg" alt="avatar placeholder" />
  }

  <span class="name" [class.hidden]="!name()" [style]="fontStyles">
    {{ name() ?? 'John Doe' }}
  </span>
</a>

<mat-menu #menu="matMenu" class="bd-menu b-av-m" [class]="this.elementKey ?? ''">
  @for (item of props?.content?.menu?.items; track item.id) {
    <button mat-menu-item (click)="menuActionClicked(item)">
      @if (item.icon) {
        <mat-icon [svgIcon]="item.icon" class="icon" />
      }
      <span class="text">{{ item.label }}</span>
    </button>
  }
</mat-menu>
